export default "__VITE_ASSET__DcfVYcmq__"